import { privateHttp } from "~/config/axios";

export interface FileThumbnail {
  fileSeq: number;
  thumbnailStatus: "PENDING" | "COMPLETE" | "FAILED" | null;
  thumbnailUrl: string | null;
}

// 첨부 100~300개의 메타데이터 조회가 한꺼번에 연결을 점유하지 않도록 제한한다.
const MAX_CONCURRENT_REQUESTS = 4;
let activeRequests = 0;
const waiting: Array<() => void> = [];

const acquireRequestSlot = (signal: AbortSignal): Promise<() => void> =>
  new Promise((resolve, reject) => {
    const abort = () => {
      const index = waiting.indexOf(start);
      if (index >= 0) waiting.splice(index, 1);
      signal.removeEventListener("abort", abort);
      reject(new DOMException("Thumbnail request cancelled", "AbortError"));
    };
    const start = () => {
      signal.removeEventListener("abort", abort);
      activeRequests += 1;
      resolve(() => {
        activeRequests -= 1;
        waiting.shift()?.();
      });
    };

    if (signal.aborted) {
      abort();
    } else if (activeRequests < MAX_CONCURRENT_REQUESTS) {
      start();
    } else {
      waiting.push(start);
      signal.addEventListener("abort", abort, { once: true });
    }
  });

export const getFileThumbnail = async (
  fileSeq: number,
  signal: AbortSignal,
): Promise<FileThumbnail> => {
  const release = await acquireRequestSlot(signal);
  try {
    // baseURL에 /api가 포함되어 있으며, 이 API는 BaseResponse로 감싸지 않는다.
    const { data } = await privateHttp.get<FileThumbnail>(`/files/${fileSeq}`, {
      signal,
      timeout: 15_000,
    });
    return data;
  } finally {
    release();
  }
};
